import { UPDATE } from "./types";

export const updateSettings = (data = {}) => {
	const store = { ...data, type: UPDATE };
	return store;
};

export const retrieveSettings = () => {
	return async (dispatch) => {
		const res = {};
		dispatch({
			type: UPDATE,
			...res?.config,
			businessId: res?.bid,
			businessCode: res?.bcode,
		});
		document.getElementById("pageloader").classList.remove("is-active");
		document.getElementById("infraloader").classList.remove("is-active");
	};
};
